<template>
  <sticky-header-layout>
    <template #header>
      <div class="filter-container">
        <div class="filter-item">
          <label-wrapper label="Store Type">
            <gx-select
              :searchable="false"
              :disabled="isLoading"
              v-model="filter.type"
              :options="storeTypeList"
              track-by="value"
              label="label"
            >
              <template #selectedLabel="{ option }">{{ option.label }}</template>
              <template #option="{ option }">{{ option.label }}</template>
            </gx-select>
          </label-wrapper>
        </div>

        <div class="filter-item">
          <label-wrapper label="Status">
            <gx-select
              :searchable="false"
              :disabled="isLoading"
              v-model="filter.status"
              :options="subscriptionStatusList"
              track-by="value"
              label="label"
            >
              <template #selectedLabel="{ option }">{{ option.label }}</template>
              <template #option="{ option }">{{ option.label }}</template>
            </gx-select>
          </label-wrapper>
        </div>
      </div>

      <div class="action-container">
        <div class="button-container">
          <el-button
            :disabled="isLoading"
            icon="el-icon-close"
            size="mini"
            @click="resetFiliter"
          >{{ $t('button.resetFilter') }}</el-button>

          <el-button
            :disabled="isLoading"
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="handleSearch"
          >{{ $t('button.search') }}</el-button>
        </div>
        <div class="button-container" style="justify-content:space-between;">
          <el-button
            :disabled="isLoading"
            type="primary"
            icon="el-icon-edit"
            size="mini"
            @click="handleCreate"
          >
            {{ $t('button.create') }}
          </el-button>
        </div>
      </div>
    </template>

    <el-table
      v-loading="isLoading"
      :data="subscriptions"
      stripe
      border
    >
      <el-table-column
        v-for="{ type, ...column } in subscriptionColumnList"
        :key="type"
        :prop="type"
        :label="column.title || $t(`table.${type}`)"
        v-bind="column.custom"
      >
        <template #default="{ row }">
          <div>
            {{ row[type] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="Terminate"
        align="center"
        width="100"
      >
        <template slot-scope="{ row }">
          <el-button
            v-if="row.subscription_id"
            size="mini"
            type="warning"
            icon="el-icon-edit"
            circle
            @click="handleShowTerminateModal(row.subscription_id)"
          />
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :visible.sync="showTerminateModal"
      class="terminate-modal"
      width="400px"
      align-center
      :before-close="handleClose"
    >
      <div class="form-item">
        <label>Terminated Date</label>
        <el-date-picker
          v-model="terminatedDate"
          :clearable="false"
          :placeholder="$t('placeholder.select')"
          type="date"
          value-format="yyyy-MM-dd"
        />
      </div>
      <div class="form-button">
        <el-button
          :loading="terminateModalIsLoading"
          type="primary"
          icon="el-icon-edit"
          size="mini"
          @click="handleTerminateSubscription"
        >Save</el-button>
      </div>

    </el-dialog>

  </sticky-header-layout>
</template>

<script>
import LabelWrapper from '../../../components/form/LabelWrapper.vue'
import { terminateStoreSubscription, getSubscriptions } from '../../../api/stores'
import fileDownload from '../../../utils/file-download'
import {
  subscriptionColumnList,
  storeTypeList,
  subscriptionStatusList,
} from '../../../const/store'

export default {
  name: 'StoreSubscriptionList',
  components: {
    LabelWrapper,
  },
  computed: {
    pickerOptions() {
      return  { 
        disabledDate(time) {
          return new Date(time) > new Date();
        }
      }
    },
  },
  data() {
    return {
      terminateModalIsLoading: false,
      selectedSubscriptionID: null,
      terminatedDate: '',
      showTerminateModal: false,
      filter: this.getDefaultFilter(),
      subscriptions: [],
      isLoading: false,
      subscriptionColumnList,
      storeTypeList,
      subscriptionStatusList,
    }
  },
  mounted() {
    this.getSubscriptions()
  },
  methods: {
    getDefaultFilter() {
      // const today = new Date();
      // const thisMonth = today.getFullYear()+'-'+(today.getMonth()+1);
      return {
        // paymentMonth: thisMonth,
        type: { value: '', label: 'All' },
        status: { value: '', label: 'All' },
      }
    },
    async getSubscriptions() {
      this.isLoading = true
      this.subscriptions = []

      try {
        const response = await getSubscriptions({
          type: this.filter.type.value,
          status: this.filter.status.value,
        })

        if (Array.isArray(response.data)) {
          this.subscriptions = response.data
        }

        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    handleSearch() {
      this.getSubscriptions()
    },
    resetFiliter() {
      this.filter = this.getDefaultFilter()
    },
    handleCreate() {
      this.$router.push({ path: `/store/subscription/create` })
    },
    handleShowTerminateModal(subscriptionID) {
      this.selectedSubscriptionID = subscriptionID
      this.showTerminateModal = true
    },
    handleClose(done) {
      this.selectedSubscriptionID = null
      this.terminatedDate = null
      done()
    },
    async handleTerminateSubscription() {
      if (!this.terminatedDate) {
        this.$alert('Please select a Terminated Date.', 'Oops..', {
          confirmButtonText: 'OK',
        })
        return
      }

      this.terminateModalIsLoading = true
      try {
        const result = await terminateStoreSubscription(this.selectedSubscriptionID, {"terminated_date":this.terminatedDate})
        this.selectedSubscriptionID = null
        this.terminatedDate = null
        this.showTerminateModal = false
        this.terminateModalIsLoading = false
        this.handleSearch()
      } catch (error) {
        this.$alert('Something went wrong', 'Oops..', {
          confirmButtonText: 'OK',
        })
        this.terminateModalIsLoading = false
      }

    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

.filter-container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-grow: 1;
  .filter-title {
    font-size: 13px;
  }
}

section {
  .filter-item {
    margin: 3px 0;
    width: 100%;
    @include mobile {
      margin: 3px 5px;
      width: calc(100% / 3 - 10px);
    }
    @include tablet {
      width: calc(100% / 4 - 10px);
    }
    @include desktop {
      width: calc(100% / 6 - 10px);
    }
  }
}

.terminate-modal .form-item {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.terminate-modal .form-button {
  margin-top: 20px;
  text-align: center;
}

::v-deep {
  .el-table__row {
    .cell {
      a {
        text-decoration: underline;
      }
    }
  }
}

</style>
